<template>
  <div class="ai-result">
    <div
      v-if="
        aiResultData.person &&
        aiResultData.person != null&&
        JSON.stringify(aiResultData.person)!='{}'
      "
    >
      <div class="graph" :id="id" ref="GraphRef"></div>
    </div>
    <div v-else v-loading="aiResultData.personLoading" element-loading-text="加载中" style="height: 500px; margin: auto">
      <el-empty v-if="!aiResultData.personLoading" description="暂无数据" style="height: 500px"></el-empty>
    </div>
    <div>
      <el-table
        :data="aiResultData.personTable"
        border
        align="center"
        style="width: 100%; margin-top: 20px;text-align: center;">
        <el-table-column
          prop="organizationName"
          label="人物名称"
        >
          <template slot-scope="{ row }">
            <div v-for="item in getOrganizationName(row.organizationName)" :key="item">{{ item }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="summary"
          label="概述"
        >
          <template slot-scope="{ row }">
            <a :href="row.url" target="_blank">{{ row.summary }}</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { Decimal } from "decimal.js";
export default {
  props: ["aiResultData"],
  components: {},
  data() {
    return {
      // 地域关系图谱
      option: {
        // title: {
        //   text: "文章传播图",
        //   left: "5%"
        // },
        tooltip: {
            position: this.handleTooltipPosition,
            enterable: true,
            borderColor: '#fff',
            formatter: function (params) {
              if (params.dataType === "node") {
                    var title = params.data.name;
                    var content = title;
                    var source = `https://baike.baidu.com/item/${params.data.name}`;
                    var link = `<a href="${source}" target="_blank">` + title + '</a>';
                    return title + '<br/>' +
                        '<div style="margin:15px 0;height:1px;background:#EBEEF5;"></div>' +
                        '百度百科：' + link;
                }
            },
        },
        animationDurationUpdate: 1500,
        animationEasingUpdate: "quinticInOut",
        grid: {
          left: "5%",
          right: "5%",
          top: "5%",
          bottom: "5%",
        },
        color: [
          "#fc8452", // 橙色
          "#fac858", // 黄色
          "#3ba272", // 深绿色
          "#91cc75", // 淡绿色
          "#5470c6", // 蓝色
        ],
        // legend: {
        //   type: "plain",
        //   orient: "vertical",
        //   left: "30px",
        //   bottom: "30px",
        //   width: "auto",
        //   height: "auto"
        // },
        series: [
          {
            type: "graph",
            layout: "force", // force 力引导  | circular 环形布局  |  none 不采用任何布局，使用节点中提供的 x， y 作为节点的位置。
            force: {
              // 节点排斥力设置
              repulsion: 100, // 斥力因子 值越大则斥力越大
              gravity: 0.12, // 节点受到的向中心的引力因子。该值越大节点越往中心点靠拢。
              edgeLength: 120, // 边的两个节点之间的距离
            },
            draggable: true, // 节点可拖拽
            symbolSize: 10,
            roam: false,
            zoom: 1,
            edgeSymbol: ["circle", "arrow"],
            edgeSymbolSize: [2, 6],
            edgeLabel: {
              fontSize: 12,
            },
            label: {
              show: true,
              position: "bottom",
              distance: 4,
              fontSize: 12,
              align: "center",
            },
            categories: [
              {
                name: "A",
              },
              {
                name: "B",
              },
              {
                name: "C",
              },
              {
                name: "D",
              },
              {
                name: "E",
              },
            ],
            data: [
              // {
              // category: 0
              // name: "web端来源"
              // }
              // {
              //   category: 1,
              //   name: "微信端来源"
              // },
              // {
              //   category: 2,
              //   name: "微博端来源"
              // },
              // {
              //   category: 3,
              //   name: "报纸端来源"
              // },
              // {
              //   category: 0,
              //   name: "web端来源2"
              // }
            ],
            links: [
              // {
              //   source: "来源为空",
              //   target: "全国妇联女性之声"
              // },
              // {
              //   source: 0,
              //   target: 1,
              //   symbolSize: [5, 14],
              //   // label: {
              //   //   show: true
              //   // },
              //   lineStyle: {
              //     width: 3,
              //     curveness: 0.2
              //   }
              // }
              // {
              //   source: "微信端来源",
              //   target: "web端来源",
              //   label: {
              //     show: true
              //   },
              //   lineStyle: {
              //     curveness: 0.2
              //   }
              // },
            ],
            itemStyle: {},
            lineStyle: {
              color: "source",
              // curveness: 0.1,
              opacity: 0.1,
            },
            emphasis: {
              focus: "adjacency",
              lineStyle: {
                width: 4,
              },
            },
          },
        ],
      },
      id: "GraphRef",
      coreWords: [],
      radio: "one",
      progressList: [],
    };
  },
  watch: {
    aiResultData: {
      handler(val) {
        this.$nextTick(() => {
          this.getData();
        })
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getOrganizationName (data) {
      let list = data.split(',')
      let arr = Array.from(new Set(list.map(item => item.trim())))
      return arr
    },
    handleTooltipPosition(point, params, dom, rect, size) {
        const [mouseX, mouseY] = point
        const [tooltipWidth, tooltipHeight] = size.contentSize
        
        // console.log(point, size.contentSize)
        
        let [posX, posY] = [0, 0]; // tooltip的显示位置

        // x位置判断
        if (mouseX < tooltipWidth) {
            // 如果左边放不下，tooltip的左侧位置=鼠标X
            posX = mouseX;
        } else {
            posX = mouseX - tooltipWidth;
        }

        if (mouseY < tooltipHeight) {
            // 如果上边放不下，tooltip的上侧位置=鼠标Y
            posY = mouseY;
        } else {
            posY = mouseY - tooltipHeight;
        }

        return [posX-5, posY-5];
    },
    // 关系图谱
    getData() {
      // let aiResultData = dataPost;
      let linksFn = [];
      let dataFn = [];
      let relateData = [];
      relateData = this.aiResultData.person;
      if (relateData != null) {
        // console.log(relateData);
        let firstNodes = [];

        let nodeArr = new Set();
        let maxLineWeight = 0; //连线分成10个等级 连线是最上级的weight
        let nodeWeight = 0; //点分成5个等级
        let g_sizes = [28, 24, 20, 16, 12]; //分成5个等级 点大小
        let g_categoryType = [0, 1, 2, 3, 4]; // 分成5类
        let g_lineStyle = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; // 分成10级线条粗细

        for (let i in relateData) {
          let di = relateData[i];
          let fi = di.from,
            ti = di.to; // 根root weight 用于线

          let rootLineWeight = new Decimal(di.weight);
          rootLineWeight = rootLineWeight.times(1000000000).toFixed(0) * 1;
          rootLineWeight > maxLineWeight && (maxLineWeight = rootLineWeight);
          // console.log("rootLineWeight", maxLineWeight); //线的最大值

          if (!nodeArr.has(fi.term)) {
            dataFn.push({
              name: fi.term,
              symbolSize: fi.weight,
            });
            // console.log(rootLineWeight);

            firstNodes.push(fi.term);
            nodeWeight < fi.weight && (nodeWeight = fi.weight);
            // console.log("点的最大值", nodeWeight);
            nodeArr.add(fi.term);
          }
          if (!nodeArr.has(ti.term)) {
            dataFn.push({
              name: ti.term,
              symbolSize: fi.weight,
            });

            nodeArr.add(ti.term);
            nodeWeight < ti.weight && (nodeWeight = ti.weight);
            // console.log("点的最大值", nodeWeight);
          }
          linksFn.push({
            source: fi.term,
            target: ti.term,
            lineStyle: {
              width: rootLineWeight,
              curveness: 0.3 // 设置曲线度
            },
          });
        }

        // console.log(linksFn);
        // console.log(dataFn);
        dataFn.forEach(function (ni, index) {
          var per = ni.symbolSize / nodeWeight;
          var i = 0;
          if (per >= 0 && per < 0.2) {
            i = 4;
          } else if (per >= 0.2 && per < 0.4) {
            i = 3;
          } else if (per >= 0.4 && per < 0.6) {
            i = 2;
          } else if (per >= 0.6 && per < 0.8) {
            i = 1;
          } else if (per >= 0.8 && per <= 1) {
            i = 0;
          }
          ni.symbolSize = g_sizes[i];
          ni.category = g_categoryType[i];
        });
        linksFn.forEach(function (ni, index) {
          // console.log(ni);
          var per = ni.lineStyle.width / maxLineWeight;
          var i = 0;
          if (per >= 0 && per < 0.1) {
            i = 10;
          } else if (per >= 0.1 && per < 0.2) {
            i = 9;
          } else if (per >= 0.2 && per < 0.3) {
            i = 8;
          } else if (per >= 0.3 && per < 0.4) {
            i = 7;
          } else if (per >= 0.4 && per <= 0.5) {
            i = 6;
          } else if (per >= 0.5 && per <= 0.6) {
            i = 5;
          } else if (per >= 0.6 && per <= 0.7) {
            i = 4;
          } else if (per >= 0.7 && per <= 0.8) {
            i = 3;
          } else if (per >= 0.8 && per <= 0.9) {
            i = 2;
          } else if (per >= 0.9 && per <= 1) {
            i = 1;
          }
          ni.lineStyle.width = g_lineStyle[i];
        });

        this.option.series[0].links = linksFn;
        this.option.series[0].data = dataFn;
        // console.log(this.option.series[0].data);
        // this.option.series[0].data = objectUnique(dataFn, "name");
        
       if (this.$refs.GraphRef) {
        this.$nextTick(() => {
          this.drawChart();
         });
        }
      }
      this.loading = false;
    },
    // 绘制折线图
    drawChart() {
      // 初始化echarts实例
      const Chart = this.$echarts.init(this.$refs.GraphRef, "null", {
          renderer: "svg" //以svg渲染可以减少内存消耗
        }
      );
      // 父组件传来的实例参数
      Chart.setOption(this.option);
      window.addEventListener("resize", () => {
        //页面大小变化后Echarts也更改大小
        Chart.resize();
      });
      var tree = this.$refs.GraphRef;

      tree.oncontextmenu = function () {
        return false;
      };
      let self = this;
      Chart.on("contextmenu", function (params) {
        if (params.dataType == "node") {
          let find = self.coreWords.find((i) => i.name == params.data.name);
          if (!find) {
            self.coreWords.push({
              name: params.data.name,
            });
          }
        } else {
          self.coreWords = [
            {
              name: params.data.source,
            },
            {
              name: params.data.target,
            },
          ];
        }
        self.$emit("getKeysArticleR", self.coreWords);
      });
      Chart.on("click", function (params) {
        let arr = [];
        if (params.dataType == "node") {
          let find = self.coreWords.find((i) => i.name == params.data.name);
          if (!find) {
            arr.push({
              name: params.data.name,
            });
          }
        } else {
          arr = [
            {
              name: params.data.source,
            },
            {
              name: params.data.target,
            },
          ];
        }
        self.$emit("getKeysArticleL", arr);
      });
    },
    //对象按字段去重
    objectUnique(arr, name) {
      var _hash = {};
      return arr.reduce(function (item, _next) {
        _hash[_next[name]] && _next[name]
          ? ""
          : (_hash[_next[name]] = true && item.push(_next));
        return item;
      }, []);
    },
    //提取
    getArrByKey(data, k) {
      let key = k || "value";
      let res = [];
      if (data) {
        data.forEach(function (t) {
          res.push(t[key]);
        });
      }
      return res;
    },
    comper(arr) {
      arr.forEach((item) => {
        item.nameDuty = item.name + "(" + item.duty + ")";
      });
      return arr.slice(0, 10);
    },
  },
};
</script>
<style lang="scss" scoped>
.ai-result {
  margin-top: 0 !important;
}
.graph {
  width: 805px;
  height: 500px;
}
.bar {
  width: 420px;
  min-height: 500px;
}
.tabs-box {
  height: 30px;
  line-height: 30px;
  width: 420px;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--bg);

  > div {
    width: 50%;
    text-align: center;
    color: var(--text-2);
    position: relative;
    cursor: pointer;

    &:hover {
      color: var(--text-1);
    }
    &.active {
      font-size: 14px;
      font-weight: 500;
      color: var(--brand);
      background: #ecf5ff;
    }
  }
}
.amplify {
  display: flex;
  position: absolute;
  top: 20%;
  right: 0%;
}
.progress-item {
  li {
    margin-top: 10px;
    cursor: pointer;
    p {
      max-width: 370px;
      font-size: 14px;
      font-weight: 400;
      color: #202d40;
    }
  }
}
/deep/ .el-progress__text {
  font-size: 14px !important;
}
</style>
